import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';

import { selectStyles } from '../../../components/inputs/Selects/Select/Select';
import utils from '../../utils';

const useSelect = ({ value, options, onChange, typeSelect, className, style = selectStyles.form, error }) => {
  const [open, setOpen] = useState(false);
  const [focusInput, setfocusInput] = useState(false);
  const inputRef = useRef(null);
  const divRef = useRef(null);
  const [selectOptions, setSelectOptions] = useState([]);
  const [words, setWords] = useState('');

  let selectValue = useMemo(() => (value ? selectOptions.find(option => option.value === value) : {}), [selectOptions, value]);
  selectValue = !!selectValue ? selectValue : {};

  useEffect(() => {
    setSelectOptions(
      options.map(option => ({
        value: option.value,
        label: option.label,
        shortLabel: option.shortLabel,
        handler: () => {
          onChange(option);
        }
      }))
    );
  }, [onChange, options]);

  useLayoutEffect(() => {
    if (open) {
      inputRef?.current?.focus?.();
    }
  }, [open]);

  const setOptions = value => {
    setWords(value);
  };

  const addOption = () => {
    const newOption = { label: words, value: words.replaceAll(' ', '').toLowerCase(), new: true };
    setSelectOptions(seleOptions =>
      seleOptions.concat({
        label: newOption.label,
        value: newOption.value,
        handler: () => onChange(newOption)
      })
    );
    onChange(newOption);
  };

  const closedOptions = () => {
    setOpen(open => {
      if (!open) {
        setWords('');
        setfocusInput(true);
      }
      return !open;
    });
  };

  const inputBlurHandler = () => {
    setfocusInput(false);
    divRef.current.focus();
  };

  const containerBlurHandler = () => {
    if (!focusInput) {
      setOpen(false);
    }
  };

  const containerClickHandler = () => {
    if (!open) {
      closedOptions();
    }
  };

  const arrowClickHandler = () => {
    if (open) {
      setOpen(false);
    }
  };

  const filteredOptions = selectOptions.filter(({ label }) => utils.filterBySearch(words, [label]));

  const filteredOptionsOrCreated =
    filteredOptions.length === 0 && typeSelect !== 'select' && typeSelect !== 'selectComplete' && words !== ''
      ? [{ value: 'created', label: 'Crear item', handler: () => addOption() }]
      : filteredOptions;

  const containerClasses = ['input-select'];
  if (style === selectStyles.filter) {
    containerClasses.push('select-filter');
  }
  if (className) {
    containerClasses.push(className);
  }
  if (error) {
    containerClasses.push('input-select-error');
  }
  return {
    open,
    divRef,
    containerBlurHandler,
    containerClickHandler,
    containerClasses,
    selectValue,
    filteredOptionsOrCreated,
    selectOptions,
    inputBlurHandler,
    closedOptions,
    inputRef,
    arrowClickHandler,
    setOptions,
    labelSelected: words
  };
};

export default useSelect;
